import React, {useEffect, useState} from 'react';
import {Skeleton} from '@material-ui/lab';
// import { Route } from 'react-router-dom'; // No longer needed if we're not routing directly here
import {
  reduxSetCreateProgram,
  reduxToggleSidePanel,
  reduxSetSidePanelEditState,
} from 'appredux/actions';
import NavigationService from 'services/NavigationService';
// import CheckIcon from 'components/CheckIcon/CheckIcon'; // Remove if not used
import {ProgramForm} from 'components/ProgramForm/ProgramForm';
import {
  IFarmInputProgramInput,
  IProduce,
  ISupplierUserProfile,
} from 'constants/interfaces';
import {PROGRAM_TYPES} from 'constants/index';
import {apiGetProduce, apiGenerateKhulaProgram} from 'constants/Api';

export default function AddOrUpdateProgram(props: {
  user: ISupplierUserProfile;
  program?: IFarmInputProgramInput;
}) {
  const [program] = useState<IFarmInputProgramInput | undefined>(props.program);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingProduce, setIsLoadingProduce] = useState(false);
  const [allProduce, setAllProduce] = useState<IProduce[]>([]);
  const [programTypes] = useState<string[]>(PROGRAM_TYPES);

  const isAdding = !props.program;

  useEffect(() => {
    setIsLoadingProduce(true);
    apiGetProduce()
      .then(setAllProduce)
      .catch((err) => {
        alert('Failed to load produce at the moment. Please try again later');
        console.error('Failed to load produce', err);
      })
      .finally(() => setIsLoadingProduce(false));
  }, []);

  const onSubmitProgram = async (submission: IFarmInputProgramInput) => {
    // Mark as editing and set loading
    reduxSetSidePanelEditState('editing');
    setIsLoading(true);

    try {
      if (isAdding) {
        // For new programs, save to Redux and navigate to create page for line editing
        reduxSetCreateProgram(submission);
        NavigationService.navigate('programs/create');
      } else {
        // For updates, save to database via API
        await apiGenerateKhulaProgram(submission);
        // Also update Redux state to reflect the changes immediately
        reduxSetCreateProgram(submission);
        // Mark as saved so parent components can refresh
        reduxSetSidePanelEditState('saved');
      }

      // Close the side panel
      reduxToggleSidePanel(false, null);
    } catch (error) {
      // Reset edit state on error
      reduxSetSidePanelEditState('idle');
      console.error('Failed to save program:', error);
      alert('Failed to save program. Please try again.');
    } finally {
      setIsLoading(false);
    }

    return;
  };

  const handleCancel = () => {
    // Reset edit state when canceling
    reduxSetSidePanelEditState('idle');
    reduxToggleSidePanel(false, null);
  };

  const handleAIClick = () => {
    alert('AI Auto Create button clicked!');
  };

  const LoadingForm = () => (
    <div className="form">
      <Skeleton variant={'rect'} height={600} />
    </div>
  );

  if (isLoading) return <LoadingForm />;

  return (
    <ProgramForm
      program={program || {}} // If no program exists, pass an empty object to handle adding a new program
      isLoading={isLoading}
      isLoadingProduce={isLoadingProduce}
      allProduce={allProduce}
      isLoadingProgramTypes={false}
      programTypes={programTypes}
      submitButtonTitle={isAdding ? 'Add Program' : 'Update Program'}
      onSubmit={onSubmitProgram}
      cancelButtonTitle="Cancel"
      onCancel={handleCancel}
      handleAIClick={handleAIClick} // Passing the AI button handler
    />
  );
}
